import React from 'react';
import { Ticket } from 'phosphor-react';
import './EntitlementPill.css';

/**
 * The gold accent token pair (`--tbx-gold` / `--tbx-gold-bg-str`) is
 * reserved by UI-SPEC for exactly four surfaces in this phase: this
 * pill in its 3 placements (facility tile, slot/confirm header,
 * success screen), plus the checkout entitlement message. Do not add
 * an alternate-styling or colour prop here — that would invite the
 * accent onto unrelated UI.
 *
 * This is the v1 tree's pill. The v2 tree gets its own local
 * `EntitlementTag` (same copy, different token namespace) — this
 * atom is not shared across both trees.
 */
export interface EntitlementPillProps {
  remainingCount?: number;
}

export const EntitlementPill: React.FC<EntitlementPillProps> = ({
  remainingCount,
}) => {
  if (remainingCount === undefined || remainingCount === null) return null;

  return (
    <span className="ent-pill">
      <Ticket size={11} weight="fill" />
      <span>{`${remainingCount} remaining`}</span>
    </span>
  );
};

export default EntitlementPill;
